import { render, staticRenderFns } from "./NormalAnswers.vue?vue&type=template&id=b5855820&"
import script from "./NormalAnswers.vue?vue&type=script&lang=js&"
export * from "./NormalAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports